export interface AdState {
  /** 广告图片地址 */
  adUrl: string;
  /** 广告类型 */
  adType: number;
  /** 广告跳转地址 */
  adRequestUrl: string;
  /** 广告名称 */
  adName: string;
  /** 广告位置 */
  adPosition: string;
  /** 广告编号 */
  adNo: string;
  appId: string;
  extraData: object
}
export interface ConsultState {
  title: string;
  num: number | string;
  img: string;
  defaultType: number;
}
export interface ArticleState {
  articleNo: string;
  articleTitle: string;
  author: string;
  id: number;
  publishTime: string;
  pushlishOperator: string;
  status: string;
  urlLink: string;
  attachmentList: any[];
}
export interface VasinfoState {
  isSelected: boolean;
  vasCode: string;
  vasIndex: number;
  vasName: string;
  totalCount: number;
  usedCount: number;
  subVasList: any[];
}

export interface RightsState {
  type: string;
  text: string;
  authType: string;
  [props: string]: any;
}

export interface SYYRightState {
  auth: boolean;
  url: string;
}
export interface OrderRightsState {
  [key: string]: VasinfoState;
}


/** 健康咨询渲染列表 */
export const CONSULT_LIST: ConsultState[] = [
  {
    title: '病情咨询',
    num: '不限次',
    img: require('./images/rights/icon_zixun.png'),
    defaultType: 0,
  },
  {
    title: '用/购药指导',
    num: '不限次',
    img: require('./images/rights/icon_gouyaozhidao.png'),
    defaultType: 3,
  },
  {
    title: '体检解读',
    num: '不限次',
    img: require('./images/rights/icon_tijianjiedu.png'),
    defaultType: 4,
  },
  {
    title: '疫苗咨询',
    num: '不限次',
    img: require('./images/rights/icon_yimiaozixun.png'),
    defaultType: 1,
  },
  {
    title: '慢病咨询',
    num: '不限次',
    img: require('./images/rights/icon_manbingzixun.png'),
    defaultType: 2,
  },
  {
    title: '导诊专科专家',
    num: '不限次',
    img: require('./images/rights/icon_kaiyao.png'),
    defaultType: 6,
  },
  {
    title: '线下就医指导',
    num: '不限次',
    img: require('./images/rights/icon_xianxiajiuyi.png'),
    defaultType: 5,
  },
];

/** 权益映射  如果查询出来的权益无法映射则不渲染 */
export const RIGHTS_OBJ = {
  advancedPayment: {
    type: 'advancedPayment',
    text: '医疗垫付',
    authType: 'real',
    defaultType: 0,
  },
  tumourSpecialMedicine: {
    type: 'tumourSpecialMedicine',
    text: '肿瘤特药',
    authType: 'real',
    defaultType: 1,
  },
  greenChannel: {
    type: 'greenChannel',
    text: '重疾绿通',
    authType: 'real',
    defaultType: 2,
  },
  proton: {
    type: 'proton',
    text: '质子重离子',
    authType: 'real',
    defaultType: 3,
  },
  homePostoperativeCare: {
    type: 'homePostoperativeCare',
    text: '术后家庭护理',
    authType: 'real',
    defaultType: 4,
  },
  mentalRelease: {
    type: 'mentalRelease',
    text: '心理倾诉',
    authType: 'phone',
    defaultType: 5,
  },
  hainanSpecialMedicine: {
    type: 'hainanSpecialMedicine',
    text: '博鳌特药',
    authType: 'real',
    defaultType: 6,
  },
  registeredAssistance: {
    type: 'registeredAssistance',
    text: '门诊挂号协助',
    authType: 'real',
    defaultType: 7,
  },
  registeredAssistanceOnce: {
    type: 'registeredAssistanceOnce',
    text: '单次门诊挂号协助',
    authType: 'real',
    defaultType: 25,
  },
  urgencyCheck: {
    type: 'urgencyCheck',
    text: '检查加急',
    authType: 'real',
    defaultType: 8,
  },
  accompanying: {
    type: 'accompanying',
    text: '就医陪诊',
    authType: 'real',
    defaultType: 9,
  },
  hospitalService: {
    type: 'hospitalService',
    text: '住院绿通',
    authType: 'real',
    defaultType: 10,
  },
  secondDiagnosis: {
    type: 'secondDiagnosis',
    text: '二次诊疗意见',
    authType: 'real',
    defaultType: 11,
  },
  Chinesemedicine: {
    type: 'Chinesemedicine',
    text: '按方开中药',
    authType: 'real',
    defaultType: 12,
  },
  CancerriskGeneDetection: {
    type: 'CancerriskGeneDetection',
    text: '肿瘤基因检测',
    authType: 'real',
    defaultType: 13,
  },
};
